// Configuration for API endpoints

const isDevelopment =
	process.env.NODE_ENV === "development" ||
	window.location.hostname === "localhost" ||
	window.location.hostname === "127.0.0.1";

// API Base URL can be configured via environment variable
// In development: defaults to http://localhost:8000
// In production: defaults to /api (same-origin with nginx proxy)
// Can be overridden with API_BASE_URL environment variable
const getApiBaseUrl = (): string => {
	// Check for explicit environment variable override
	if (process.env.API_BASE_URL) {
		return process.env.API_BASE_URL;
	}

	// Default behavior based on environment
	return isDevelopment
		? "http://localhost:8000" // Development: separate backend server
		: "/api"; // Production: same origin with /api prefix
};

export const API_BASE_URL = getApiBaseUrl();

export const config = {
	apiBaseUrl: API_BASE_URL,
	cmsBaseUrl: "givewise.org.hk",
	isDevelopment,
};
